/* eslint-disable no-shadow-restricted-names */
/* eslint-disable no-undef */
/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;

window.lazySizesConfig.minSize = 20;			// 40
window.lazySizesConfig.expand = 370;//260;		// 370-500
window.lazySizesConfig.expFactor = 1.3;			// 1.5;
window.lazySizesConfig.hFac = 0.6;				// 0.8;
window.lazySizesConfig.loadMode = 2;

window.lazySizesConfig.lazyClass = 'lazyload';
window.lazySizesConfig.loadedClass = 'lazyloaded';
window.lazySizesConfig.loadingClass = 'lazyloading';
window.lazySizesConfig.srcAttr = 'data-src';
window.lazySizesConfig.srcsetAttr = 'data-srcset';

window.lazySizesConfig.loadHidden = true;					// true

window.lazySizesConfig.ricTimeout = 100;					// 0
window.lazySizesConfig.throttleDelay = 125;					// 125

window.lazySizesConfig.unloadClass = 'lazyunload';
window.lazySizesConfig.unloadedClass = 'lazyunloaded';
window.lazySizesConfig.unloadHidden = true;					// true
window.lazySizesConfig.emptySrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';		// (default: transparent data uri): The src to be used as unload image.
window.lazySizesConfig.autoUnload = false;					// true
window.lazySizesConfig.unloadPixelThreshold = 15*15;		// 60000

import '../vendor/lazysizes.cjs';
import '../vendor/ls.unload.cjs';
